import { Box, Typography } from "@mui/material";

import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";

export function Footer() {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-evenly" }}>
      <Box>
        <Typography variant="body2" align="center">
          {i18n("login.Subtitle")}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" align="center">
          {i18n("trial.footer.support.1")}{" "}
          <Link component="a" href="mailto:support@sosinventory.com">
            support@sosinventory.com
          </Link>{" "}
          {i18n("trial.footer.support.2")}{" "}
          <Link component="a" href="tel:1-817-422-5909">
            817-422-5909
          </Link>
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" align="center">
          <Link
            component="a"
            href="https://www.sosinventory.com/privacy-policy"
          >
            {i18n("trial.PrivacyPolicy")}
          </Link>
          {" | "}
          <Link
            component="a"
            href="https://www.sosinventory.com/terms-of-service"
          >
            {i18n("trial.TermsOfService")}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
